import { deepMerge } from '~/utils/licensePlateRenewalHelpers';
import {
    SET_CUSTOMER_DRIVER_LICENSE,
    SET_CUSTOMER_HEALTH_CARD,
    SET_CUSTOMER_LICENSE_PLATE,
    SET_CUSTOMER_PHOTOCARD,
    SET_CUSTOMER_PROFILE,
    SET_CREATE_ACCOUNT_PROFILE,
    SET_AI_PHOTO_DATA,
    SET_ERRORS,
    SET_IS_LOADING,
    SET_REGISTERED_PRODUCTS,
    SET_RENEWAL_REMINDERS,
    SET_ADDRESS_CHANGE_DATA,
    RESET_ADDRESS_CHANGE_DATA,
    SET_ADDRESS_CHANGE_ELIGIBILITY_QUESTIONS,
    SET_ADDRESS_CHANGE_TERMS_CONDITIONS_AGREED,
    ADDRESS_CHANGE_SUCCESS,
    ADDRESS_CHANGE_SELECT_PRODUCT,
    SET_INBOX_DATA,
    SET_RENEWAL_PRODUCT_TYPE,
    SET_RENEWAL_TERMS_AND_CONDTIONS_AGREED,
    SET_RENEWAL_ELIGIBILITY_RESPONSE,
    SET_RENEWAL_DRIVERS_LICENCE_DETAILS,
    SET_RENEWAL_HEALTH_CARD_DETAILS,
    SET_RENEWAL_CERTIFY_INFO,
    SET_RENEWAL_CONFIRM_VISION_CHANGE,
    SET_RENEWAL_CONTACT_DETAILS,
    SET_RENEWAL_PHOTOCARD_DETAILS,
    RESET_RENEWAL_DATA,
    SET_RENEWAL_PAYMENT_STATE,
    SET_RENEWAL_DL_ORDER_STATUS,
    SET_RENEWAL_HC_ORDER_STATUS,
    SET_RENEWAL_REMINDERS_DATA,
    RESET_RENEWAL_REMINDERS_DATA,
    RESET_PAYFINE,
    SET_INBOX_MODE,
    SET_INBOX_PAGE_NUMBER,
    RESET_RENEWAL_DRIVERS_LICENCE_DETAILS,
    RESET_RENEWAL_PHOTOCARD_DETAILS,
    RESET_STATE,
    LICENSE_PLATE_RENEWAL_DETAILS,
    LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_START,
    LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_END,
    LICENSE_PLATE_RENEWAL_RESET,
    LICENSE_PLATE_RENEWAL_NO_PAYMENT,
    LICENSE_PLATE_RENEWAL_DETAILS_UPDATE,
    LICENSE_PLATE_RENEWAL_DETAILS_REMOVE,
    LICENSE_PLATE_RENEWAL_DETAILS_RESET,
    SET_INTENDED_FLOW,
    SET_RENEWAL_FLOW,
    SET_RENEWAL_IS_VERIFICATION_REQUIRED,
    SET_RENEWAL_SUPPRESS_INELIGIBLE_BANNER,
    SHOW_RENEWAL_ALERT,
    SET_REFERRER_AS_DASHBOARD,
    SET_MESSAGES,
    SET_PAY_FINE_FINE_INFO,
    SET_PAY_FINE_GUEST_INFO,
    SET_SELECTED_FINES,
    SET_SELECTED_FINES_VAL,
    SET_CHECK_AMP,
    SET_CHECK_REINST,
    SHOW_CANCEL_ORDER_SUCCSS_MESSAGE,
    SET_PAYFINE_ATTEMPTS,
    SET_PAYMENT_ORDER_DATA,
    DECLINED_ORDER_STATUS,
    RESET_CREATE_ACCOUNT_PROFILE,
    SET_DL_RENEWAL_ELIGIBILITY_DATA,
    SET_OPC_RENEWAL_ELIGIBILITY_DATA,
    SET_HC_RENEWAL_ELIGIBILITY_DATA,
    SET_ADMIN_MESSAGES,
    SET_ADMIN_MESSAGES_LOADING,
    SET_ADMIN_MESSAGES_ERROR,
    RESET_CHECK_AMP,
    RESET_CHECK_REINST,
    SET_CHECK_DRFINE,
    SET_CHECK_NSF,
    SET_RENEWAL_IS_ONTARIO_RESIDENT,
    SET_RENEWAL_OPC_ORDER_STATUS,
    SET_DRIVERS_ABSTRACT,
    RESET_DRIVERS_ABSTRACT,
    SET_VEHICLE_ABSTRACT_UNCERTIFIED,
    ADD_ABSTRACT_TO_UNCERTIFIED_VEHICLE_ABSTRACTS,
    RESET_VEHICLE_ABSTRACT_UNCERTIFIED,
    SET_DRAFTS_AND_FORMS,
    SET_CALLER_INFO,
    SET_PRODUCTS_PHOTO_CARD,
    SET_PRODUCTS_DRIVERS_LICENCE,
    SET_CUSTOMER_PROFILE_ERRORS,
    SET_PAYFINE_INIT_BY,
    SET_VERIFY_PRODUCT_INFO,
} from './actions';
import INITIAL_STATE from './state';
import { AIPhotoData, ActionProps, LicensePlateDetail, StoreStateProps } from './types';

const getProductRenewalState = (state: StoreStateProps) => ({
    isVerificationRequired: state?.productRenewal?.isVerificationRequired ?? false,
    suppressIneligibleBanner: state?.productRenewal?.suppressIneligibleBanner ?? false,
    ...state?.productRenewal,
});

// reducer
function reducer(state: StoreStateProps, action: ActionProps): StoreStateProps {
    switch (action.type) {
        case SET_PRODUCTS_PHOTO_CARD: {
            return {
                ...state,
                products: {
                    ...(state.products ?? {}),
                    photoCard: action?.payload?.products?.photoCard,
                },
            };
        }
        case SET_PRODUCTS_DRIVERS_LICENCE: {
            return {
                ...state,
                products: {
                    ...(state.products ?? {}),
                    driversLicence: action?.payload?.products?.driversLicence,
                },
            };
        }
        case SET_INTENDED_FLOW: {
            return {
                ...state,
                intendedFlow: action?.payload?.intendedFlow ?? '',
            };
        }
        case SET_RENEWAL_FLOW: {
            const VALID_RENEWAL_FLOWS: readonly string[] = [
                'DLV',
                'OPCV',
                'HCV',
                'DLHCV',
                'IACV',
                '',
            ];
            const incoming = action?.payload?.renewalFlow ?? '';
            const safeRenewalFlow = VALID_RENEWAL_FLOWS.includes(incoming)
                ? incoming
                : state.renewalFlow;
            return {
                ...state,
                renewalFlow: safeRenewalFlow,
            };
        }
        case SET_RENEWAL_IS_VERIFICATION_REQUIRED: {
            return {
                ...state,
                productRenewal: {
                    ...getProductRenewalState(state),
                    isVerificationRequired:
                        !!action?.payload?.productRenewal?.isVerificationRequired,
                },
            };
        }
        case SET_RENEWAL_SUPPRESS_INELIGIBLE_BANNER: {
            return {
                ...state,
                productRenewal: {
                    ...getProductRenewalState(state),
                    suppressIneligibleBanner:
                        !!action?.payload?.productRenewal?.suppressIneligibleBanner,
                },
            };
        }
        case SET_IS_LOADING: {
            return {
                ...state,
                isLoading: !!action?.payload?.isLoading,
            };
        }
        case SET_ERRORS: {
            return {
                ...state,
                errors: action?.payload?.errors,
            };
        }
        case SET_CUSTOMER_PROFILE_ERRORS: {
            return {
                ...state,
                profileErrors: action?.payload?.profileErrors,
            };
        }
        case SET_ADMIN_MESSAGES: {
            return {
                ...state,
                admin: {
                    ...state?.admin,
                    messages: action?.payload?.admin?.messages,
                },
            };
        }
        case SET_ADMIN_MESSAGES_LOADING: {
            return {
                ...state,
                admin: {
                    ...state?.admin,
                    isLoading: !!action?.payload?.admin?.isLoading,
                },
            };
        }
        case SET_ADMIN_MESSAGES_ERROR: {
            return {
                ...state,
                admin: {
                    ...state?.admin,
                    error: action?.payload?.admin?.error,
                },
            };
        }
        case SET_MESSAGES: {
            return {
                ...state,
                messages: action?.payload?.messages,
            };
        }
        case SET_CUSTOMER_PROFILE: {
            return {
                ...state,
                ...(action?.payload?.customer && {
                    customer: action.payload.customer,
                }),
            };
        }
        case SET_PAYFINE_ATTEMPTS: {
            return {
                ...state,
                payFineAttempts: action?.payload?.payFineAttempts,
            };
        }
        case SET_PAYFINE_INIT_BY: {
            return {
                ...state,
                payFineInitBy: action.payload?.payFineInitBy,
            };
        }
        case SET_CREATE_ACCOUNT_PROFILE: {
            return {
                ...state,
                ...(action?.payload?.createAccount && {
                    createAccount: action.payload.createAccount,
                }),
            };
        }
        case RESET_CREATE_ACCOUNT_PROFILE: {
            return {
                ...state,
                createAccount: undefined,
            };
        }
        case SET_CUSTOMER_DRIVER_LICENSE: {
            return {
                ...state,
                ...(action?.payload?.customer && {
                    customer: {
                        ...state?.customer,
                        products: {
                            ...state?.customer?.products,
                            ...{
                                driverLicense: action?.payload?.customer?.products?.driverLicense,
                            },
                        },
                    },
                }),
            };
        }
        case SET_CUSTOMER_LICENSE_PLATE: {
            return {
                ...state,
                ...(action?.payload?.customer && {
                    customer: {
                        ...state?.customer,
                        products: {
                            ...state?.customer?.products,
                            licencePlates: action?.payload?.customer?.products?.licencePlates,
                        },
                    },
                }),
            };
        }
        case SET_CUSTOMER_PHOTOCARD: {
            return {
                ...state,
                ...(action?.payload?.customer && {
                    customer: {
                        ...state?.customer,
                        products: {
                            ...state?.customer?.products,
                            ...{
                                photoCard: action?.payload?.customer?.products?.photoCard,
                            },
                        },
                    },
                }),
            };
        }
        case SET_CUSTOMER_HEALTH_CARD: {
            return {
                ...state,
                ...(action?.payload?.customer && {
                    customer: {
                        ...state?.customer,
                        products: {
                            ...state?.customer?.products,
                            ...{
                                healthCard: action?.payload?.customer?.products?.healthCard,
                            },
                        },
                    },
                }),
            };
        }
        case SET_REFERRER_AS_DASHBOARD: {
            return {
                ...state,
                isReferredByDashboard: !!action?.payload?.isReferredByDashboard,
            };
        }
        case SHOW_RENEWAL_ALERT: {
            return {
                ...state,
                isReminderActive: !!action?.payload?.isReminderActive,
            };
        }
        case SET_RENEWAL_REMINDERS: {
            return {
                ...state,
                ...(action?.payload?.renewalReminder && {
                    renewalReminder: {
                        ...state?.renewalReminder,
                        ...action.payload.renewalReminder,
                    },
                }),
            };
        }
        case RESET_PAYFINE: {
            return {
                ...state,
                selectedFinesObj: {},
                payFine: {},
            };
        }
        case SET_PAY_FINE_FINE_INFO: {
            return {
                ...state,
                ...(Object.keys(action?.payload?.payFine || {}).length === 0
                    ? { payFine: {} } // Clear payFine if it's an empty object
                    : {
                          // Else, merge the current payFine with the new data
                          payFine: {
                              ...state?.payFine,
                              ...action?.payload?.payFine,
                          },
                      }),
            };
        }
        case SET_PAY_FINE_GUEST_INFO: {
            return {
                ...state,
                ...(Object.keys(action?.payload?.payFineGuest || {}).length === 0
                    ? { payFineGuest: {} }
                    : {
                          payFineGuest: {
                              ...state?.payFineGuest,
                              ...action?.payload?.payFineGuest,
                          },
                      }),
            };
        }
        case SET_PAYMENT_ORDER_DATA: {
            return {
                ...state,
                ...(action?.payload?.paymentOrderDate && {
                    paymentOrderDate: {
                        ...state.paymentOrderDate,
                        ...action.payload.paymentOrderDate,
                    },
                }),
            };
        }
        case SET_SELECTED_FINES: {
            return {
                ...state,
                ...(action?.payload?.selectedFinesObj && {
                    selectedFinesObj: {
                        ...state?.selectedFinesObj,
                        ...action.payload.selectedFinesObj,
                    },
                }),
            };
        }
        case SET_SELECTED_FINES_VAL: {
            return {
                ...state,
                selectedFinesValue: action?.payload?.selectedFinesValue,
            };
        }
        case SET_CHECK_AMP: {
            return {
                ...state,
                ...(action?.payload?.checkAmp && {
                    checkAmp: action.payload.checkAmp,
                }),
            };
        }
        case SET_CHECK_DRFINE: {
            return {
                ...state,
                ...(action?.payload?.checkDriversFine && {
                    checkDriversFine: action.payload.checkDriversFine,
                }),
            };
        }
        case SET_CHECK_NSF: {
            return {
                ...state,
                ...(action?.payload?.checknsf && {
                    checkNSF: action.payload.checknsf,
                }),
            };
        }
        case RESET_CHECK_AMP: {
            return {
                ...state,
                checkAmp: [],
            };
        }
        case SET_CHECK_REINST: {
            return {
                ...state,
                ...(action?.payload?.checkReinst && {
                    checkReinst: action.payload.checkReinst,
                }),
            };
        }
        case RESET_CHECK_REINST: {
            return {
                ...state,
                checkReinst: [],
            };
        }
        case SET_REGISTERED_PRODUCTS: {
            return {
                ...state,
                ...(action?.payload?.registeredProducts && {
                    registeredProducts: action.payload.registeredProducts,
                }),
            };
        }
        case SET_ADDRESS_CHANGE_DATA: {
            return {
                ...state,
                addressChange: {
                    ...state?.addressChange,
                    ...action?.payload?.addressChange,
                    ...(action?.payload?.addressChange?.sameAsResidential && {
                        mailingAddress: undefined,
                    }),
                    ...action?.payload?.selectedPCAddressInfo,
                },
            };
        }
        case RESET_ADDRESS_CHANGE_DATA: {
            return {
                ...state,
                addressChange: {},
            };
        }
        case SET_ADDRESS_CHANGE_ELIGIBILITY_QUESTIONS: {
            return {
                ...state,
                addressChange: {
                    ...state?.addressChange,
                    ...action?.payload?.addressChange,
                },
            };
        }
        case ADDRESS_CHANGE_SELECT_PRODUCT: {
            return {
                ...state,
                addressChange: {
                    ...state?.addressChange,
                    ...action?.payload?.addressChange,
                },
            };
        }
        case ADDRESS_CHANGE_SUCCESS: {
            return {
                ...state,
                addressChange: {
                    ...state?.addressChange,
                    ...action?.payload?.addressChange,
                },
            };
        }
        case SET_ADDRESS_CHANGE_TERMS_CONDITIONS_AGREED: {
            return {
                ...state,
                ...(typeof action.payload?.addressChange?.agreedTermsAndConditions !==
                    'undefined' && {
                    addressChange: {
                        ...state?.addressChange,
                        agreedTermsAndConditions:
                            !!action.payload?.addressChange?.agreedTermsAndConditions,
                    },
                }),
            };
        }
        case SET_AI_PHOTO_DATA: {
            return {
                ...state,
                aiPhotoData: {
                    ...state?.aiPhotoData,
                    ...action?.payload?.aiPhotoData,
                } as AIPhotoData,
            };
        }
        case SET_INBOX_DATA: {
            return {
                ...state,
                ...(action?.payload?.inbox && {
                    inbox: {
                        ...state?.inbox,
                        ...action.payload.inbox,
                    },
                }),
            };
        }
        case SET_INBOX_MODE: {
            return {
                ...state,
                ...(action?.payload?.inbox && {
                    inbox: {
                        ...state?.inbox,
                        mode: action?.payload?.inbox?.mode ?? 'inbox',
                        messages: undefined,
                        numOfMessages: 0,
                        pageNumber: 1,
                        inboxError: undefined,
                    },
                }),
            };
        }
        case SET_INBOX_PAGE_NUMBER: {
            return {
                ...state,
                ...(action?.payload?.inbox && {
                    inbox: {
                        ...state?.inbox,
                        pageNumber: action?.payload?.inbox?.pageNumber ?? 1,
                    },
                }),
            };
        }
        case SET_RENEWAL_PRODUCT_TYPE: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.renewalType && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        renewalType: action.payload.productRenewal.renewalType,
                        skippedRenewalOptionsPage:
                            action.payload.productRenewal.skippedRenewalOptionsPage,
                    },
                }),
            };
        }
        case SET_RENEWAL_TERMS_AND_CONDTIONS_AGREED: {
            return {
                ...state,
                ...(typeof action.payload?.productRenewal?.agreedTermsAndConditions !==
                    'undefined' && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        agreedTermsAndConditions:
                            !!action.payload?.productRenewal?.agreedTermsAndConditions,
                    },
                }),
            };
        }
        case SET_RENEWAL_ELIGIBILITY_RESPONSE: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.eligibilityQuestions && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        eligibilityQuestions: {
                            ...state?.productRenewal?.eligibilityQuestions,
                            ...action?.payload?.productRenewal?.eligibilityQuestions,
                        },
                    },
                }),
            };
        }
        case SET_RENEWAL_DRIVERS_LICENCE_DETAILS: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.driversLicenceDetails && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        driversLicenceDetails:
                            action?.payload?.productRenewal?.driversLicenceDetails,
                        photoCardDetails: undefined,
                    },
                }),
            };
        }
        case SET_RENEWAL_PHOTOCARD_DETAILS: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.photoCardDetails && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        photoCardDetails: action?.payload?.productRenewal?.photoCardDetails,
                        driversLicenceDetails: undefined,
                    },
                }),
            };
        }
        case SET_RENEWAL_IS_ONTARIO_RESIDENT: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.isOntarioResident && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        isOntarioResident: action.payload?.productRenewal?.isOntarioResident,
                    },
                }),
            };
        }
        case RESET_RENEWAL_DRIVERS_LICENCE_DETAILS: {
            return {
                ...state,
                productRenewal: {
                    ...getProductRenewalState(state),
                    driversLicenceDetails: undefined,
                },
            };
        }
        case RESET_RENEWAL_PHOTOCARD_DETAILS: {
            return {
                ...state,
                productRenewal: {
                    ...getProductRenewalState(state),
                    photoCardDetails: undefined,
                },
            };
        }
        case SET_RENEWAL_HEALTH_CARD_DETAILS: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.healthCardDetails && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        healthCardDetails: action?.payload?.productRenewal?.healthCardDetails,
                    },
                }),
            };
        }
        case SET_RENEWAL_CERTIFY_INFO: {
            return {
                ...state,
                ...(action.payload?.productRenewal && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        certifyRenewalInfo: action?.payload?.productRenewal?.certifyRenewalInfo,
                    },
                }),
            };
        }
        case SET_RENEWAL_CONFIRM_VISION_CHANGE: {
            return {
                ...state,
                ...(action.payload?.productRenewal && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        confirmVisionChange: action?.payload?.productRenewal?.confirmVisionChange,
                    },
                }),
            };
        }
        case SET_RENEWAL_CONTACT_DETAILS: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.contactDetails && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        contactDetails: action?.payload?.productRenewal?.contactDetails,
                    },
                }),
            };
        }
        case SET_DL_RENEWAL_ELIGIBILITY_DATA: {
            return {
                ...state,
                productRenewal: {
                    ...getProductRenewalState(state),
                    eligibilityData: {
                        ...state?.productRenewal?.eligibilityData,
                        eResidencyCheck:
                            action?.payload?.productRenewal?.eligibilityData?.eResidencyCheck,
                        driverLicenseEligibility:
                            action?.payload?.productRenewal?.eligibilityData
                                ?.driverLicenseEligibility,
                        photoCardEligibility: undefined,
                    },
                    transactionCategory: action?.payload?.productRenewal?.transactionCategory,
                },
            };
        }
        case SET_OPC_RENEWAL_ELIGIBILITY_DATA: {
            return {
                ...state,
                productRenewal: {
                    ...getProductRenewalState(state),
                    eligibilityData: {
                        ...state?.productRenewal?.eligibilityData,
                        eResidencyCheck:
                            action?.payload?.productRenewal?.eligibilityData?.eResidencyCheck,
                        photoCardEligibility:
                            action?.payload?.productRenewal?.eligibilityData?.photoCardEligibility,
                        driverLicenseEligibility: undefined,
                    },
                    transactionCategory: action?.payload?.productRenewal?.transactionCategory,
                },
            };
        }
        case SET_HC_RENEWAL_ELIGIBILITY_DATA: {
            return {
                ...state,
                productRenewal: {
                    ...getProductRenewalState(state),
                    eligibilityData: {
                        ...state?.productRenewal?.eligibilityData,
                        healthCardEligibility:
                            action?.payload?.productRenewal?.eligibilityData?.healthCardEligibility,
                    },
                    transactionCategory: action?.payload?.productRenewal?.transactionCategory,
                },
            };
        }
        case SET_RENEWAL_HC_ORDER_STATUS: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.orderStatus?.healthCard && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        orderStatus: {
                            ...state?.productRenewal?.orderStatus,
                            healthCard: action.payload?.productRenewal?.orderStatus?.healthCard,
                        },
                    },
                }),
            };
        }
        case SET_RENEWAL_DL_ORDER_STATUS: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.orderStatus?.driversLicence && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        orderStatus: {
                            ...state?.productRenewal?.orderStatus,
                            driversLicence:
                                action.payload?.productRenewal?.orderStatus?.driversLicence,
                        },
                    },
                }),
            };
        }
        case SET_RENEWAL_OPC_ORDER_STATUS: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.orderStatus?.photoCard && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        orderStatus: {
                            ...state?.productRenewal?.orderStatus,
                            photoCard: action.payload?.productRenewal?.orderStatus?.photoCard,
                        },
                    },
                }),
            };
        }
        case SET_RENEWAL_PAYMENT_STATE: {
            return {
                ...state,
                ...(action.payload?.productRenewal?.orderStatus?.payment && {
                    productRenewal: {
                        ...getProductRenewalState(state),
                        orderStatus: {
                            ...state?.productRenewal?.orderStatus,
                            payment: {
                                ...state?.productRenewal?.orderStatus?.payment,
                                ...action.payload?.productRenewal?.orderStatus?.payment,
                            },
                        },
                    },
                }),
            };
        }
        case RESET_RENEWAL_DATA: {
            return {
                ...state,
                productRenewal: {
                    isVerificationRequired: false,
                    suppressIneligibleBanner: false,
                },
                renewalFlow: '',
            };
        }
        case SET_RENEWAL_REMINDERS_DATA: {
            return {
                ...state,
                ...(action.payload?.renewalReminder?.submittedData && {
                    renewalReminder: {
                        ...state?.renewalReminder,
                        submittedData: action.payload?.renewalReminder?.submittedData,
                    },
                }),
            };
        }
        case RESET_RENEWAL_REMINDERS_DATA: {
            return {
                ...state,
                renewalReminder: undefined,
            };
        }
        case LICENSE_PLATE_RENEWAL_DETAILS: {
            const combinedDetails = (
                prevDetails: LicensePlateDetail[],
                newDetails: LicensePlateDetail[]
            ): LicensePlateDetail[] => {
                return [...prevDetails, ...newDetails].reduce((acc: LicensePlateDetail[], curr) => {
                    const existingDetail = acc.find(
                        item => item.licensePlateNumber === curr.licensePlateNumber
                    );

                    if (existingDetail) {
                        deepMerge(existingDetail, curr);
                    } else {
                        acc.push(curr);
                    }

                    return acc;
                }, []);
            };
            return {
                ...state,
                ...(action.payload?.licensePlateRenewal && {
                    licensePlateRenewal: {
                        ...state?.licensePlateRenewal,
                        ...action?.payload?.licensePlateRenewal,
                    },
                }),
                ...(action.payload?.licensePlateRenewal?.details && {
                    licensePlateRenewal: {
                        ...state?.licensePlateRenewal,
                        details: combinedDetails(
                            state?.licensePlateRenewal?.details || [],
                            action?.payload?.licensePlateRenewal?.details || []
                        ),
                    },
                }),
                ...(action.payload?.licensePlateRenewal?.contact && {
                    licensePlateRenewal: {
                        ...state?.licensePlateRenewal,
                        contact: {
                            ...action?.payload?.licensePlateRenewal?.contact,
                        },
                    },
                }),
            };
        }
        case LICENSE_PLATE_RENEWAL_DETAILS_RESET:
            return {
                ...state,
                ...(action.payload?.licensePlateRenewal && {
                    licensePlateRenewal: {
                        details: [],
                    },
                }),
            };
        case LICENSE_PLATE_RENEWAL_DETAILS_UPDATE:
        case LICENSE_PLATE_RENEWAL_DETAILS_REMOVE: {
            return {
                ...state,
                ...(action.payload?.licensePlateRenewal && {
                    licensePlateRenewal: {
                        ...state?.licensePlateRenewal,
                        ...action?.payload?.licensePlateRenewal,
                    },
                }),
                ...(action.payload?.licensePlateRenewal?.details && {
                    licensePlateRenewal: {
                        ...state?.licensePlateRenewal,
                        details: action?.payload?.licensePlateRenewal?.details || [],
                    },
                }),
                ...(action.payload?.licensePlateRenewal?.contact && {
                    licensePlateRenewal: {
                        ...state?.licensePlateRenewal,
                        contact: {
                            ...action?.payload?.licensePlateRenewal?.contact,
                        },
                    },
                }),
            };
        }
        case LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_START:
        case LICENSE_PLATE_RENEWAL_MAKE_PAYMENT_END:
        case LICENSE_PLATE_RENEWAL_NO_PAYMENT: {
            if (!action?.payload?.licensePlateRenewal?.orderStatus) {
                return state;
            }

            const prevOrderStatus = state?.licensePlateRenewal?.orderStatus;
            const newOrderStatus = action?.payload?.licensePlateRenewal?.orderStatus;
            return {
                ...state,
                licensePlateRenewal: {
                    ...state.licensePlateRenewal,
                    orderStatus: {
                        ...prevOrderStatus,
                        ...newOrderStatus,
                        ...(newOrderStatus?.payment && {
                            payment: {
                                ...prevOrderStatus?.payment,
                                ...newOrderStatus?.payment,
                            },
                        }),
                    },
                },
            };
        }
        case LICENSE_PLATE_RENEWAL_RESET: {
            return {
                ...state,
                licensePlateRenewal: { details: [] },
            };
        }
        case SHOW_CANCEL_ORDER_SUCCSS_MESSAGE: {
            return {
                ...state,
                cancelOrderSuccessMessage: !!action?.payload?.cancelOrderSuccessMessage,
            };
        }
        case DECLINED_ORDER_STATUS: {
            return {
                ...state,
                declineOrderStatus: !!action?.payload?.declineOrderStatus,
            };
        }
        case SET_DRAFTS_AND_FORMS: {
            return {
                ...state,
                draftsAndForms: action?.payload?.draftsAndForms ?? [],
            };
        }
        case SET_DRIVERS_ABSTRACT: {
            return {
                ...state,
                driversAbstract: {
                    ...state?.driversAbstract,
                    ...action?.payload?.driversAbstract,
                },
            };
        }
        case RESET_DRIVERS_ABSTRACT: {
            return {
                ...state,
                driversAbstract: undefined,
            };
        }

        case SET_VEHICLE_ABSTRACT_UNCERTIFIED: {
            return {
                ...state,
                vehicleAbstractUncertified: {
                    ...state?.vehicleAbstractUncertified,
                    ...action?.payload?.vehicleAbstractUncertified,
                },
            };
        }
        case ADD_ABSTRACT_TO_UNCERTIFIED_VEHICLE_ABSTRACTS: {
            const abstract = action?.payload?.vehicleAbstract;
            if (!abstract) {
                return state;
            }
            return {
                ...state,
                vehicleAbstractUncertified: {
                    ...state?.vehicleAbstractUncertified,
                    abstracts: [...(state?.vehicleAbstractUncertified?.abstracts || []), abstract],
                    abstractType: undefined,
                    vin: undefined,
                    licensePlate: undefined,
                    date: undefined,
                    dateDay: undefined,
                    dateMonth: undefined,
                    dateYear: undefined,
                },
            };
        }
        case RESET_VEHICLE_ABSTRACT_UNCERTIFIED: {
            return {
                ...state,
                vehicleAbstractUncertified: undefined,
            };
        }

        case SET_CALLER_INFO: {
            return {
                ...state,
                callerInfo: {
                    ...state?.callerInfo,
                    ...action?.payload?.callerInfo,
                },
            };
        }

        case SET_VERIFY_PRODUCT_INFO: {
            return {
                ...state,
                verifyProductInfo: {
                    binding: action.payload?.verifyProductInfo?.binding || '',
                    email: action.payload?.verifyProductInfo?.email || '',
                },
            };
        }

        case RESET_STATE:
            return INITIAL_STATE;
        default:
            return state;
    }
}

function reducerWithPersistence(state: StoreStateProps, action: ActionProps): StoreStateProps {
    const newState = reducer(state, action);

    // In order to use the state on next browser reload, this side effect is needed
    // to persist the state in browser's session storage
    if (typeof sessionStorage !== 'undefined') {
        sessionStorage.setItem('cxpState', JSON.stringify(newState));
    }

    return newState;
}

export default reducerWithPersistence;
